<template>
  <div>

    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
      :collapse-action="true">

      <div class="vx-row">
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">General Search</label>
          <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full" />
        </div>

        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Account Handler</label>
          <v-select :disabled="!$can('executive-admin')" name="staffs" :closeOnSelect="false" :clearable="false"
            v-model="filters['account-handler']" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :reduce="option => option.value" label="name" multiple />
        </div>

        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Date From</label>
          <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
            placeholder="Choose Date" />
          <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
            placeholder="Choose Date" />
        </div>

        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Date To</label>
          <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
            placeholder="Choose Date" />
          <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
            placeholder="Choose Date" />
        </div>

        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select :options="status_options" label="label" :reduce="option => option.slug" v-model="filters['status']" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Industrial Sector</label>
          <v-select v-on:input="onChangeIndustrySector" name="industry_sectors" :closeOnSelect="false" :clearable="false"
            v-model="filters['sector']" :options="industry_sectors" :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :reduce="option => option.value" label="name" multiple />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Industrial Sub Sector</label>
          <v-select name="industry_sub_sectors" :closeOnSelect="false" :clearable="false" v-model="filters['sub-sector']"
            :options="industry_sub_sectors" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.id" label="name"
            multiple />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Customer Sources</label>
          <v-select v-on:input="onChangeCustomerSource" name="customer_sources" :closeOnSelect="false" :clearable="false"
            v-model="filters['source']" :options="customer_sources" :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :reduce="option => option.value" label="name" multiple />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-100 text-bold">Customer Sub Sources</label>
          <v-select name="customer_sub_sources" :closeOnSelect="false" :clearable="false" v-model="filters['sub-source']"
            :options="customer_sub_sources" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.id" label="name"
            multiple />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-100 text-bold">Show only new enquries</label>
          <vs-switch v-model="filters['new']" icon-pack="feather" vs-icon-on="icon-check-circle"
                              vs-icon-off="icon-slash" class="mt-3 w-16">
                      <span slot="on">Yes</span>
                      <span slot="off">No</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="clearFilters()">CLEAR</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-row">
      <div class="vx-col w-1/4 cursor-pointer" @click.stop="onClickTile('new_enquiries')">
        <shortcut-card hideChart class="mb-base" :icon="'BellIcon'" icon-right :statistic="summary_data.new_enquiries"
          :iconRight="true" :statisticTitle="'New Enquiries'" :color="'#ed134a'" />
      </div>
      <div class="vx-col w-1/4 cursor-pointer" @click.stop="onClickTile('leads')">
        <shortcut-card hideChart class="mb-base" :icon="'AwardIcon'" icon-right
          :statistic="summary_data.open_active_leads" :iconRight="true" :statisticTitle="'Open Leads'"
          :color="'#39b24b'" />
      </div>
      <div class="vx-col w-1/4">
        <shortcut-card hideChart class="mb-base" :icon="'MessageSquareIcon'" icon-right
          :statistic="summary_data.awaiting_feedback" :iconRight="true" :statisticTitle="'Awaiting Sample Feedback'"
          :color="'#39b24b'" />
      </div>
      <div class="vx-col w-1/4">
        <shortcut-card hideChart class="mb-base" :icon="'BookmarkIcon'" icon-right :statistic="summary_data.open_briefs"
          :iconRight="true" :statisticTitle="'Open Briefs'" :color="'#39b24b'" />
      </div>
      <div class="vx-col w-1/4">
        <shortcut-card hideChart class="mb-base" :icon="'PowerIcon'" icon-right :statistic="summary_data.open_projects"
          :iconRight="true" :statisticTitle="'Open Projects'" :color="'#39b24b'" />
      </div>
      <div class="vx-col w-1/4">
        <shortcut-card hideChart class="mb-base" :icon="'DollarSignIcon'" icon-right
          :statistic="summary_data.pipeline_value | report_thousand_seperator(0)" :iconRight="true"
          :statisticTitle="'Pipeline Value (GBP)'" :color="'#39b24b'" />
      </div>
      <div class="vx-col w-1/4">
        <shortcut-card hideChart class="mb-base" :icon="'DollarSignIcon'" icon-right
          :statistic="summary_data.converted_to_sales | report_thousand_seperator(0)" :iconRight="true"
          :statisticTitle="'Convert to Sale (GBP)'" :color="'#39b24b'" />
      </div>
      <div class="vx-col w-1/4">
        <shortcut-card hideChart class="mb-base" :icon="'BarChartIcon'" icon-right :statistic="summary_data.success_rate"
          :iconRight="true" :statisticTitle="'Success Rate'" :color="'#39b24b'" />
      </div>
    </div>


    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="">
          <template slot="actions">
          </template>
          <div slot="no-body" class="">
            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="marketing_leads" @sort="handleSort"
              :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th sort-key="code">CODE</vs-th>
                <vs-th width="5%"></vs-th>
                <vs-th>COMPANY NAME</vs-th>
                <vs-th width="10%">EMAIL</vs-th>
                <vs-th>FULL NAME</vs-th>
                <vs-th sort-key="status">STATUS</vs-th>
                <vs-th sort-key="created_at">CREATED DATE</vs-th>
                <vs-th></vs-th>
                <!-- <vs-th width="5%">ASSESSMENT ACTIONS</vs-th> -->
                <vs-th width="10%">LEAD ACTIONS</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data"
                  @click.native="onClickUserEdit(data[indextr].id, data[indextr].status)" class="cursor-pointer">

                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td :data="data[indextr].code">
                    <vs-chip v-if="tr.open_count === 0" color="danger" transparent>new</vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].company_name">
                    {{ data[indextr].company_name || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].role">
                    {{ data[indextr].status | crm_status_name_formatter }}
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatterToDate(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <!-- <vx-tooltip v-for="(status, index) in status_options" :key="index" class="mr-2 mb-1"
                        :text="`change to ${status.label} status`" position="top"
                        v-if="status.slug !== data[indextr].status">
                        <vs-button @click.stop="onClickChangeStatus(data[indextr].id, status.slug)" size="small"
                          :color="status.color" type="filled" icon-pack="feather" icon="icon-">{{ status.label
                          }}</vs-button>
                      </vx-tooltip> -->
                    </div>
                  </vs-td>

                  <!-- <vs-td>
                    <div class="vx-row">
                      <vx-tooltip  class="mr-2" text="ASSESS SALES OPPORTUNITY"
                        position="top" v-if="!data[indextr].customer_id">
                        <vs-button @click.stop="onClickProcess(data[indextr].id, data[indextr].company_name)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-plus"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip  class="mr-2" text="SHOW PREVIOUS OPPORTUNITY"
                        position="top">
                        <vs-button @click.stop="onClickViewBantData(data[indextr].id)" size="small" color="warning"
                          type="border" icon-pack="feather" icon="icon-align-justify"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td> -->

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" text="VIEW CUSTOMER" position="top" v-if="data[indextr].customer_id">
                        <vs-button @click.stop="onClickCustomerView(data[indextr].customer_id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-external-link"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="mr-2" text="VIEW/UPDATE" position="top" v-if="!data[indextr].customer_id">
                        <vs-button @click.stop="onClickUserEdit(data[indextr].id, data[indextr].status)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <!-- <vx-tooltip class="mr-2" text="LEAD SITES MANAGE" position="top">
                        <vs-button @click.stop="onClickLeadAddress(data[indextr].id)" size="small" color="primary"
                          type="filled" icon-pack="feather" icon="icon-home"></vs-button>
                      </vx-tooltip> -->
                      <!-- <vx-tooltip class="mr-2" text="DETAILS OF SAMPLE ORDERS SENT" position="top">
                        <vs-button @click.stop="onClickSampleOrdersForLead(data[indextr].id)" size="small" color="primary"
                          type="filled" icon-pack="feather" icon="icon-box"></vs-button>
                      </vx-tooltip> -->
                      <vx-tooltip v-can="'create-edit-forecast-tool'" class="mr-2" text="CREATE/UPDATE FORECAST"
                        position="top">
                        <vs-button @click.stop="onClickViewForecast(data[indextr].id)" size="small" color="primary"
                          type="border" icon-pack="feather" icon="icon-link-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
    <create-marketing-lead-pop-up ref="createMarketingLeadPopUp" />
    <create-bant-pop-up ref="createBantPopUp" />
    <view-bant-data-pop-up ref="viewBantDataPopUp" />
    <marketing-leads-address-pop-up ref="marketingLeadsAddressPopUp" />
    <view-lead-sample-orders-pop-up ref="viewLeadSampleOrdersPopUp" />
    <update-forecast ref="updateForecast" @refreshData="refreshData" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "@/constants/config";
const CrmRepository = RepositoryFactory.get('crm');
import CreateMarketingLeadPopUp from '@/components/popups/crm/marketing-leads/CreateMarketingLeadPopUp.vue'
import CreateBantPopUp from '@/components/popups/crm/marketing-leads/CreateBantPopUp.vue';
import ViewBantDataPopUp from '@/components/popups/crm/marketing-leads/ViewBantDataPopUp.vue'
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import MarketingLeadsAddressPopUp from '@/components/popups/crm/marketing-leads/MarketingLeadsAddressPopUp.vue'
import ViewLeadSampleOrdersPopUp from '@/components/popups/crm/marketing-leads/ViewLeadSampleOrdersPopUp .vue'
import { mapActions, mapGetters } from 'vuex';
const CustomerRepository = RepositoryFactory.get('customer');
const CustomerSourceRepository = RepositoryFactory.get('customer_source')
import ShortcutCard from '@/components/shortcut-cards/ShortcutCard.vue';
import UpdateForecast from "@/components/popups/forecast-tool/UpdateForecast";

export default {
  name: 'SuspectMartketingLeadList',
  data() {
    return {
      marketing_leads: [],
      checkBox1: null,
      status_options: [
        { label: 'New Enquiries', slug: 'Pending', color: 'warning' },
        { label: 'Lead', slug: 'Lead', color: 'primary' },
        { label: 'Subscriber', slug: 'Subscriber', color: 'primary' },
        { label: 'Opportunity', slug: 'Opportunity', color: 'warning' },
        { label: 'Closed', slug: 'Closed NIO', color: 'danger' },
        { label: 'Junk', slug: 'Junk', color: 'danger' }
      ],
      summary_filters: {
        'from': null,
        'to': null
      },
      filters: {
        search: '',
        'sub-sector': null,
        'sub-source': null,
        'account-handler': null,
        'new': true
      },
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      industry_sub_sectors: [],
      customer_sub_sources: [],
      summary_data: {}
    }
  },
  components: {
    'v-select': vSelect,
    flatPickr,
    CreateMarketingLeadPopUp,
    ViewBantDataPopUp,
    CreateBantPopUp,
    MarketingLeadsAddressPopUp,
    ViewLeadSampleOrdersPopUp,
    ShortcutCard,
    UpdateForecast
  },
  created() {
    this.filters['account-handler'] = [this.$store.getters.currentUserId]
  },
  methods: {
    ...mapActions(['fetchStaffs', 'fetchIndustrySections', 'fetchCustomerSources']),
    async refreshData() {
      this.fetchMarketingLeads()
    },
    async onClickUserEdit(id, status) {
      if (status === 'Opportunity') {
        this.$router.push(`/pages/crm/marketing-leads-opportunities/${id}`)
      } else if (status === 'Lead') {
        this.$router.push(`/pages/crm/marketing-leads-suspect/${id}`)
      } else if( status === 'Pending' ) {
        this.$route.push(`/pages/crm/marketing-leads/${id}`)
      } else if( status === 'Closed NIO' ) {
        this.$route.push(`/pages/crm/marketing-leads-closed/${id}`)
      } else if( status === 'Subscriber' ) {
        this.$route.push(`/pages/crm/marketing-leads-influence/${id}`)
      } else if( status === 'Junk' ) {
        this.$route.push(`/pages/crm/marketing-leads/${id}`)
      }
    },
    async onClickLeadAddress(id) {
      await this.$refs.marketingLeadsAddressPopUp.openPopup(id)
    },
    async onClickSampleOrdersForLead(id) {
      await this.$refs.viewLeadSampleOrdersPopUp.openPopup(id)
    },
    async fetchMarketingLeads() {
      this.$vs.loading()
      try {
        const { data } = await CrmRepository.getListOfMarketingLeads(this.page, this.filterQuery , this.perPage, this.sort)
        this.marketing_leads = data.data
        this.meta.total = data.total
        this.meta.last_page = data.last_page
        this.meta.per_page = data.per_page
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickChangeStatus(id, status) {
      this.$vs.loading()
      try {
        await CrmRepository.changeMarketingLeadStatus(id, { status })
        await this.refreshData()
      } catch (error) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },

    async onClickCreateMarketingLead() {
      this.$refs.createMarketingLeadPopUp.openPopup()
    },
    onClickProcess(id, company_name) {
      this.$refs.createBantPopUp.openPopup(id, company_name)
    },
    onClickCustomerView(id) {
      this.$router.push(`/pages/manage-nimble/customers/${id}`)
    },
    onClickViewBantData(id) {
      this.$refs.viewBantDataPopUp.openPopup(id)
    },

    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },

    filterQueryUpdate() {
      this.fetchMarketingLeads()
      this.fetchDashboardReport()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchMarketingLeads()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchMarketingLeads()
      }
    },
    async onChangeIndustrySector(ids) {
      this.filters['sub-sector'] = null
      if (ids.length === 0) return null
      try {
        const { data } = (await CustomerRepository.getIndustrySubSectors({ ids: ids })).data
        this.industry_sub_sectors = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onChangeCustomerSource(ids) {
      this.filters['sub-source'] = null
      if (ids.length === 0) return null
      try {
        const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: ids })).data
        this.customer_sub_sources = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchDashboardReport() {
      try {
        const formatted_query = this.filterQuery.replace("filter[account-handler]", "filter[account-handler-id]");
        const { data } = (await CrmRepository.getCrmDashbordReportData(formatted_query)).data
        this.summary_data = data
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async onClickViewForecast(id) {
      const lead = this.marketing_leads.find((x) => x.id === id)
      if (!!lead) {
        await this.$refs.updateForecast.openPopup({ data: lead, customer_type: 'lead' })
      }
      // this.$router.push(`/pages/forecasts?create_lead=${id}`)
    },
    clearFilters() {
      this.filters = this.$can('executive-admin') ? { 'new' : true } : { 'account-handler': [this.$store.getters.currentUserId], 'new' : true };
    },
    onClickTile(type) {
      switch (type) {
        case 'new_enquiries':
          this.$router.push('/pages/crm/marketing-leads')
          break;
        case 'leads':
          this.$router.push('/pages/crm/marketing-leads-suspect')
          break;
      }
    }

  },
  watch: {
    page() {
      this.fetchMarketingLeads()
    },
    perPage() {
      this.fetchMarketingLeads()
    },
    'summary_filters': {
      handler() {
        this.fetchDashboardReport()
      },
      deep: true,
      immediate: true
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
  mounted() {
    if (this.$route.query.search) {
      this.filters.search = this.$route.query.search
      this.$router.replace({ query: null })
    }
    this.fetchDashboardReport()
    this.fetchStaffs()
    this.fetchIndustrySections()
    this.fetchCustomerSources()
    this.setFilterId('lead_list_filters',['search','account-handler', 'from', 'to', 'sector', 'sub-sector', 'source', 'sub-source'])
  },
  computed: {
    ...mapGetters(['staffs', 'industry_sectors', 'customer_sources'])
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
